import React from 'react';
import get from 'lodash/get';
import { useIntl } from 'react-intl';
import { DateInput } from '@tesla/informed-tds';
import { useTCLFormApi } from '../../../hooks';
import messages from './messages';

const LocalizedDate = ({ ...props }) => {
  const intl = useIntl();
  const { formatMessage, locale } = intl;
  const { errorMessages } = useTCLFormApi();
  const errorMessage = get(
    errorMessages,
    'required._',
    formatMessage(messages.DateRequiredMessage)
  );

  return <DateInput {...props} locale={locale} errorMessage={errorMessage} />;
};

export default LocalizedDate;
